import BonusLevels from './BonusLevels';
import Collections from './Collections';
import Levels from './Levels';

export default { BonusLevels, Collections, Levels };
